export default __webpack_public_path__ + "static/media/Wolf's Belt of the Covert Trail.cbe4c3c2.jpg";